import { render } from "./LoadingScreen.vue?vue&type=template&id=3bff9256&scoped=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=ts"
export * from "./LoadingScreen.vue?vue&type=script&lang=ts"

import "./LoadingScreen.vue?vue&type=style&index=0&id=3bff9256&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3bff9256"

export default script